import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

import { Template } from './template.model'
import { UsersService } from '../users/users.service'
import { TimeOrDatePipe } from '../shared/time-or-date.pipe';
import { Workflow } from '../workflows/workflow.model'
import { CollapseWidthAnimation } from '../shared/collapse-width.animation';

@Component({
  selector: 'app-recent-templates',
  templateUrl: './recent-templates.component.html',
  styleUrls: ['./recent-templates.component.scss'],
  animations: [CollapseWidthAnimation]
})
export class RecentTemplatesComponent implements OnInit {
  @Output() templateSelected = new EventEmitter<{template: Template, workflow: Workflow}>();
  @Output() workflowSelected = new EventEmitter<null>();
  @Output() favoriteToggled = new EventEmitter<Template>();
  @Input() selectedTemplate: Template;
  @Input() templates: Template[] = [];
  @Input() workflows: Workflow[] = [];
  @Input() workflowLoading: boolean = false;

  constructor(private usersService: UsersService) { }

  ngOnInit() { }

  selectTemplate(template) {
    let workflow: Workflow;
    if (template != null) {
      workflow = this.workflows.find((w) => w.id === template.workflowId);
    }
    this.templateSelected.emit({template: template, workflow: workflow})
  }

  toggleFavorite(template) {
    this.favoriteToggled.emit(template)
  }
}


// WEBPACK FOOTER //
// ./src/app/templates/recent-templates.component.ts